// Shop ajax
const axiosGetShopList = async (parent, slug) => {
  const action = parent.querySelector('[data-action]').value;
  const listInner = parent.querySelector('.shop-module__inner');

  const formDataInput = {
    action,
    filteredCategory: slug,
    nonce: await getNonceForAction(action),
  };

  try {
    const { data } = await axios.post(localData.siteURL, formDataInput);
    listInner.innerHTML = '';

    if (listInner && data.data.html_list) {
      listInner.innerHTML = data.data.html_list;
    }

    const [baseUrl] = window.location.href.split('?');
    const urlParams = ['filteredCategory']
      .filter((item) => formDataInput[item] && formDataInput[item].length > 0)
      .map((item) => `${item}=${formDataInput[item]}`)
      .join('&');

    window.history.pushState({}, '', baseUrl + (urlParams ? `?${urlParams}` : ''));
    cardList.scrollIntoView();
  } catch (err) {
    console.error(err);
  }
};

// Shop Filter
attachEvent('.shop-filter__trigger', 'click', (ev) => {
  const parentElem = ev.target.closest('.shop-filter');
  const content = parentElem.querySelector('.shop-filter__nav');
  parentElem.classList.toggle('is-open');
  slideToggle(content, 300, 'block');
});

const updatePlaceholder = (mainParent) => {
  const placeholder = mainParent.querySelector('.shop-filter__placeholder');
  const defaultPlaceholder = placeholder.getAttribute('data-placeholder');
  const activeItems = mainParent.querySelectorAll('.shop-filter__item.is-active');
  const selectedTexts = Array.from(activeItems).map((item) => item.textContent.trim());
  placeholder.innerHTML = selectedTexts.join(', ') || defaultPlaceholder;
};

attachEvent('.shop-filter__item', 'click', (ev) => {
  const mainParent = ev.target.closest('.shop-filter');
  const parentEle = ev.target.closest('.shop-filter__item');

  if (mainParent.classList.contains('shop-filter--multiselect')) {
    parentEle.classList.toggle('is-active');
  } else {
    const activeItem = mainParent.querySelector('.shop-filter__item.is-active');
    activeItem?.classList.remove('is-active');
    parentEle.classList.add('is-active');
  }

  updatePlaceholder(mainParent);

  const parentShopModuleElem = ev.target.closest('.shop-module');
  const dataSlug = parentEle.getAttribute('data-slug');

  axiosGetShopList(parentShopModuleElem, dataSlug);
});

document.querySelectorAll('.shop-filter').forEach((mainParent) => {
  updatePlaceholder(mainParent);
});
